var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-7",
    transform: "translate(-1026.000000, -1414.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apple",
    transform: "translate(1026.000000, 1414.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "testimonial",
    d: "M18.5,29.3c2.6-4.5,7.3-7.3,12.3-7.4c0,0,0.1,0,0.2,0c2.1,0,4.2,0.8,6,1.5c1.3,0.5,2.5,1,3.4,1 c0.8,0,1.9-0.4,3.3-1c1.9-0.8,4.3-1.7,6.8-1.7c0.3,0,0.6,0,1,0c2.1,0.1,7.4,0.8,10.9,5.9c0.1,0.1,0.1,0.2,0.1,0.4 c0,0.1-0.1,0.2-0.2,0.3l0,0c-1,0.6-6,4-6,10.4c0.1,7.9,6.7,10.8,7.4,11.1c0,0,0,0,0,0c0.2,0.1,0.3,0.4,0.3,0.6l0,0.1 c-0.4,1.3-1.6,4.7-4,8.2c-2.3,3.3-4.9,7.1-9.2,7.2c-2,0-3.3-0.5-4.7-1.1c-1.3-0.6-2.7-1.2-4.9-1.2c-2.3,0-3.7,0.6-5.1,1.2 c-1.2,0.5-2.5,1.1-4.3,1.1c-0.1,0-0.1,0-0.2,0c-3.8,0-6.6-3.5-9.3-7.4C16.7,50.7,13.5,37.8,18.5,29.3z M51.4,8 c0.2,0,0.5,0.2,0.5,0.4c0.4,3.2-0.8,6.7-3.1,9.5c-2.2,2.6-5.4,4.2-8.3,4.2c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4-0.2-0.4-0.4 c-0.5-3.6,1.3-7.1,3.2-9.2C44.7,10,48.3,8.1,51.4,8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.37b75402891663051a674fccda8166eb.svg";
export { ForwardRef as ReactComponent };